import React, {createContext, useContext, useState, useCallback} from 'react';
import {useHistory} from "react-router-dom";
import {isEqual, isFunction} from "lodash";

const PriceQuotesPageContext = createContext('');

export function usePriceQuotesPageContext() {
  return useContext(PriceQuotesPageContext);
}

export function PriceQuotesPageProvider({children}) {
  const history = useHistory();
  const [queryParams, setQueryParamsBase] = useState({});
  const setQueryParams = useCallback(nextQueryParams => {
    setQueryParamsBase(prevQueryParams => {
      if (isFunction(nextQueryParams)) {
        nextQueryParams = nextQueryParams(prevQueryParams);
      }

      if (isEqual(prevQueryParams, nextQueryParams)) {
        return prevQueryParams;
      }
      for (let key in nextQueryParams) {
        if (nextQueryParams.hasOwnProperty(key) && !nextQueryParams[key]) delete nextQueryParams[key]
      }
      const path = history.location.pathname;
      const newQueryParams = new URLSearchParams(nextQueryParams);
      history.replace(`${path}?${newQueryParams.toString()}`);

      return nextQueryParams;
    });
  }, []);

  const [loading, setLoading] = useState(false);
  const [showLinkModal, setShowLinkModal] = useState(false);
  const [linkPriceQuoteID, setLinkPriceQuoteID] = useState(null);

  const value = {
    queryParams,
    setQueryParamsBase,
    setQueryParams,
    loading,
    setLoading,
    showLinkModal,
    setShowLinkModal,
    linkPriceQuoteID,
    setLinkPriceQuoteID,
  };

  return <PriceQuotesPageContext.Provider value={value}>{children}</PriceQuotesPageContext.Provider>;
}
